import { render, staticRenderFns } from "./MsTeams-Tag-Selector.vue?vue&type=template&id=628d7c76&lang=pug"
import script from "./MsTeams-Tag-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsTeams-Tag-Selector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports